import { motion } from 'motion/react';
import styled from 'styled-components';
import { COLORS, device } from '../../../constants';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionCtaCircleProps {
  className?: string;
  size: number;
}

export const MotionCtaCircle = ({ className, size }: MotionCtaCircleProps) => {
  return <MotionCtaCircleWrapper className={className} size={size} />;
};

const MotionCtaCircleWrapper = styled(motion.div)<{
  size: number;
}>`
  width: ${({ size }) => size}px;
  aspect-ratio: 1 / 1;
  position: absolute;
  top: calc(50% + 22px);
  left: 50%;
  border-radius: 50%;
  transform: translate(-50%, -50%);

  &::after {
    content: '';
    display: block;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    border-radius: 50%;
    border-width: 1px;
    border-color: ${COLORS.ACTIVE_ITEM};
    border-style: dashed;
    opacity: 0;
    transform: scale(1);
    pointer-events: none;
    animation: pulse-ring-cta infinite;
    animation-duration: ${ANIMATION_CONFIG.keyFrames.cta.duration}s;
    animation-delay: ${ANIMATION_CONFIG.keyFrames.cta.delay}s;
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }

  @media screen and (${device.md}) {
    width: ${({ size }) => size / 2}px;

    &::after {
      width: ${({ size }) => size / 2}px;
      height: ${({ size }) => size / 2}px;
    }
  }
  @media screen and (${device.sm}) {
    width: ${({ size }) => size / 4}px;

    &::after {
      width: ${({ size }) => size / 4}px;
      height: ${({ size }) => size / 4}px;
    }
  }

  @keyframes pulse-ring-cta {
    0% {
      opacity: 0.5;
      transform: scale(1);
    }
    25% {
      opacity: 0.35;
      transform: scale(1.5);
    }
    50% {
      opacity: 0.2;
      transform: scale(2);
    }
    75% {
      opacity: 0.1;
      transform: scale(2.5);
    }
    100% {
      opacity: 0;
      transform: scale(3.5);
    }
  }
`;
